import {FEATURE_FLAGS, MODULE_TYPES} from '../../../constants';
import {hasModule} from './ModuleUtil';

const CACHE = new Set();

const SESSION_STORAGE_KEY = 'availableFeatureFlags';

const isSessionStorageAvailable = () => typeof window !== 'undefined' && window.sessionStorage;

export type Feature = {key: string};
export const setAvailableFeatureFlags = (availableFeatureFlags: Feature[]): void => {
	if (Array.isArray(availableFeatureFlags)) {
		if (isSessionStorageAvailable()) {
			sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(availableFeatureFlags));
		}

		CACHE.clear();
		availableFeatureFlags.forEach(featureFlag => {
			CACHE.add(featureFlag.key);
		});
	}
};

export const hasFeatureFlag = (featureFlag: string): boolean => {
	if (CACHE.size === 0) {
		const sessionFeatureFlags = isSessionStorageAvailable() ? sessionStorage.getItem(SESSION_STORAGE_KEY) : null;
		const availableFeatureFlags = sessionFeatureFlags ? JSON.parse(sessionFeatureFlags) : [];
		setAvailableFeatureFlags(availableFeatureFlags);
	}

	return CACHE.has(featureFlag);
};

export const hasTimeLocking = (): boolean => {
	return hasModule(MODULE_TYPES.TIME_LOCKING);
};

// The client-contacts feature (IGNITE-490/491/493/494) is gated by BOTH the
// `extending_client_contacts` feature flag and the NEW_CLIENT_CONTACTS_FEATURE module.
// Centralised here so the mandatory ≥2-week flag cleanup (AGENTS.md) is a single-site edit.
export const isClientContactsFeatureEnabled = (): boolean =>
	hasFeatureFlag(FEATURE_FLAGS.EXTENDING_CLIENT_CONTACTS) && hasModule(MODULE_TYPES.NEW_CLIENT_CONTACTS_FEATURE);

export const hasTimeApproval = (): boolean => {
	return hasModule(MODULE_TYPES.TIME_LOCKING);
};

export const usesSso = (company?: {oktaEnabled?: boolean; oneloginEnabled?: boolean; AADEnabled?: boolean}): boolean => {
	const {oktaEnabled, oneloginEnabled, AADEnabled} = company || {};
	return !!oktaEnabled || !!oneloginEnabled || !!AADEnabled;
};

export const usingTimeApproval = (companyUseTimeApproval: boolean): boolean => {
	return companyUseTimeApproval && hasTimeApproval();
};

export const usingInternalTimeApproval = (companyUseInternalTimeApproval: boolean): boolean => {
	return hasTimeApproval() && companyUseInternalTimeApproval;
};

export const usingTimeOffApproval = (companyUseTimeOffApproval: boolean): boolean => {
	return companyUseTimeOffApproval && hasTimeApproval() && hasFeatureFlag('pto_timesheet_allocation_linking');
};
